import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  logEvent,
  setDefaultEventParameters,
  setUserProperties
} from "firebase/analytics";
import { firebaseConfig } from './firebase/config';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Keep the legacy and modern experiences distinguishable even though they use
// the same Firebase Analytics property. Default parameters apply to every
// event emitted by the app, while the user property makes audience/report
// segmentation straightforward in GA4.
setDefaultEventParameters({
  ui_version: 'legacy',
  app_surface: 'web_app'
});
setUserProperties(analytics, { ui_version: 'legacy' });
logEvent(analytics, 'experience_loaded', { ui_version: 'legacy' });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
